import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import TagsOuvidoriaCard from './components/MotivosOuvidoriaCard';

const TagsOuvidoriaMain = () => (
  <Container fluid>
    <Row>
      <Col md={12}>
        <PageHeader
          title=""
          routeSegments={[
            { name: 'Inicio' },
            { name: 'Tags da Ouvidoria' },
          ]}
        />
      </Col>
    </Row>

    <Row>
      <Col md={12}>
        <TagsOuvidoriaCard />
      </Col>
    </Row>
  </Container>
);

export default TagsOuvidoriaMain;
